import {
	fullInsuranceImage,
	citiesDropOffImage,
	unlimitedKmImage,
	deliveryImage,
	driverImage
} from 'assets/images/icons/additionalServices';
import useBooking from '../../../../context/useBooking';
import { SERVICES_GROUP, SERVICES_TYPES } from 'helpers';

const useAdditionalServices = () => {
	const {
		booking: { services }
	} = useBooking();

	const getImage = (type) => {
		switch (type) {
			case SERVICES_TYPES.UNLIMITED_KM:
				return unlimitedKmImage;
			case SERVICES_TYPES.DRIVER:
				return driverImage;
			case SERVICES_TYPES.INSURANCE:
				return fullInsuranceImage;
			case SERVICES_TYPES.DROP_CITY:
				return citiesDropOffImage;
			case SERVICES_TYPES.DELIVERY:
				return deliveryImage;
			default:
				return null;
		}
	};

	const filteredServices = services
		.filter((service) => service.group === SERVICES_GROUP.INTERNAL)
		.map(({ id, price: { nett }, selected, label, type }) => ({
			id,
			price: nett,
			selected,
			label,
			src: getImage(type)
		}));

	const servicesExist = !!filteredServices.length;

	return { filteredServices, servicesExist };
};

export default useAdditionalServices;
